<template>
  <span class="store-locator-icon">
    <span class="icon icon--marker"></span>
  </span>
</template>

<script>
export default {
  name: 'StoreLocatorIcon',
};
</script>
